<template>
  <div class="card vue-avatar-cropper-demo text-center">
    <div class="card-body">
      <img :src="user.avatar" id="pick-avatar" title="Chọn Hình Ảnh" class="card-img avatar">
      <!-- <div class="card-img-overlay">
        <button class="btn btn-primary btn-sm" id="pick-avatar">Select a new image</button>
        <button class="btn btn-primary btn-sm" @click="pickAvatar" v-show="false">Select a new image</button>
      </div> -->
      <h5 class="card-title mb-0">{{ user.nickname }}</h5>
      <div class="text-muted">{{ user.username }}</div>
      <span 
        v-if="user.url_avatar !== null && user.url_avatar !== ''"
        @click="deleteAvatar" class="btn-delete">{{ $t('common.delete') }}</span>
    </div>
    <!-- <div class="card-footer text-muted" v-html="message"></div> -->
    <avatar-cropper
      @uploading="handleUploading"
      @uploaded="handleUploaded"
      @completed="handleCompleted"
      @error="handlerError"
    />
  </div>
</template>

<script>
import AvatarCropper from "@/components/Avatar/AvatarCropper.vue";
import utils from "@/lib/utils"
export default {
  name: "Avatar",
  components: { AvatarCropper },
  props: {
    urlAvatar: {
      type: String,
      default: () => {
        return null
      }
    }
  },
  data() {
    return {
      name: "Avatar",
      message: "",
      user: {
        id: 1,
        nickname: "",
        username: "",
        avatar: "",
        url_avatar: ""
      },
      avatarDefault: require("../../assets/images/avatar-default.png"),
    };
  },
  watch: {
    'urlAvatar': function () {
      if (!utils.isNull(this.urlAvatar)) {
        this.user.avatar = this.urlAvatar
        this.user.url_avatar = this.urlAvatar
      }
    }
  },
  mounted() {
    this.user.avatar = require("../../assets/images/avatar-default.png")
  },
  methods: {
    pickAvatar: function(e) {
      e.preventDefault();
      alert("Chức Năng Đang Được Hoàn Thiện");
    },
    handleUploading(form, xhr) {
      this.message = "uploading...";
    },
    handleUploaded(res_url) {
      if (res_url != null) {
        this.user.avatar = res_url;
        this.user.url_avatar = res_url;

        // Maybe you need call vuex action to
        // update user avatar, for example:
        // this.$dispatch('updateUser', {avatar: res_url})
        this.message = "user avatar updated.";
        this.$emit("completed", this.user.url_avatar);
      }
    },
    handleCompleted(response, res_url, xhr) {
      this.message = "upload completed.";
    },
    handlerError(message, type, xhr) {
      this.message = "Oops! Something went wrong...";
    },
    deleteAvatar: function() {
      this.user.avatar = require("../../assets/images/avatar-default.png")
      this.user.url_avatar = null
      this.$emit("completed", this.user.url_avatar);
    }
  }
};
</script>

<style scoped>
.vue-avatar-cropper-demo {
  max-width: 18em;
  margin: 0 auto;
}
.avatar {
  width: 160px;
  border-radius: 6px;
  display: block;
  margin: 20px auto;
}
.card-img-overlay {
  display: none;
  transition: all 0.5s;
}
.card-img-overlay button {
  /* margin-top: 20vh; */
}
.card:hover .card-img-overlay {
  display: block;
}
.btn-delete {
  position: relative;
  bottom: 15px;
  cursor: pointer;
  color: red;
}
.btn-delete:hover {
  text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// src/components/Avatar/Avatar.vue